import { TextAreaItem, InputItem } from "../../../forms/FormItems";
import {
  SettingsDataSelect,
  CrmUsersSelect,
} from "../../../forms/AutoCompleteFormItem";
import DateAndHourItem from "../../../forms/DateAndHourItem";

export const getFormItems = (
  type,
  {
    scopePrefix,
    disabledStartDate,
    disabledStartHours,
    disabledStartMinutes,
    disabledEndDate,
    disabledEndHours,
    disabledEndMinutes,
    activeEntity,
    entity,
  }
) => {
  const callItems = () => [
    {
      name: "subject",
      required: true,
      comp: <InputItem name="subject" category="log" required />,
    },
    {
      name: "body",
      comp: <TextAreaItem name="body" id category="log" rows={4} />,
    },
  ];
  const taskItems = ({ scopePrefix }) => [
    {
      name: "subject",
      required: true,
      comp: <InputItem name="subject" category="log" required={true} />,
    },
    {
      name: "priority_id",
      required: true,
      comp: (
        <SettingsDataSelect
          name="priority_id"
          category="task"
          settingsdataName={"system_tables/crm/crm_task_priorities"}
          required={true}
          type="list"
        />
      ),
    },
    {
      name: "status_id",
      required: true,
      comp: (
        <SettingsDataSelect
          name="status_id"
          category="task"
          settingsdataName={"system_tables/crm/crm_task_statuses"}
          required={true}
          type="list"
        />
      ),
    },
    {
      name: "assigned_to_id",
      required: true,
      comp: (
        <CrmUsersSelect
          name="assigned_to_id"
          category="task"
          extraParams={{
            scopePrefix: scopePrefix,
            filter: {},
          }}
          required={true}
        />
      ),
    },
    {
      name: "task_type_id",
      comp: (
        <SettingsDataSelect
          name="task_type_id"
          category="task"
          settingsdataName={"system_tables/crm_task_types"}
          type="list"
          extraParams={{
            current: 1,
            pageSize: 100,
            filter: {
              $and: [
                {
                  entity:
                    entity === "patients" || entity === "crm/patients"
                      ? "patient"
                      : "employee",
                },
              ],
            },
          }}
        />
      ),
    },
    {
      name: "sub_task_type_id",
      comp: (
        <SettingsDataSelect
          name="sub_task_type_id"
          category="task"
          settingsdataName={"system_tables/crm_sub_task_types"}
          type="list"
          extraParams={{
            current: 1,
            pageSize: 100,
            filter: {
              $and: [{ crm_task_type_id: activeEntity?.task_type_id }],
            },
          }}
          waitForFetch={!activeEntity?.task_type_id}
          disabled={!activeEntity?.task_type_id}
        />
      ),
    },
    {
      name: "due_date",
      required: true,
      comp: <DateAndHourItem required={true} name="due_date" category="task" />,
    },
  ];

  const eventItems = ({
    disabledStartDate,
    disabledStartHours,
    disabledStartMinutes,
    disabledEndDate,
    disabledEndHours,
    disabledEndMinutes,
  }) => [
    {
      name: "subject",
      required: true,
      comp: <InputItem name="subject" category="log" required={true} />,
    },
    {
      name: "body",
      required: false,
      comp: <TextAreaItem name="body" id={true} category="event" rows={4} />,
    },
    {
      name: "start_time",
      required: true,
      comp: (
        <DateAndHourItem
          required={true}
          name="start_time"
          category="event"
          disabledDate={disabledStartDate}
          disabledMinutes={disabledStartMinutes}
          disabledHours={disabledStartHours}
        />
      ),
    },
    {
      name: "end_time",
      required: true,
      comp: (
        <DateAndHourItem
          required={true}
          name="end_time"
          category="event"
          disabledDate={disabledEndDate}
          disabledMinutes={disabledEndMinutes}
          disabledHours={disabledEndHours}
        />
      ),
    },
  ];

  if (type === "call") {
    return callItems();
  } else if (type === "task") {
    return taskItems({ scopePrefix });
  } else {
    return eventItems({
      disabledStartDate,
      disabledStartHours,
      disabledStartMinutes,
      disabledEndDate,
      disabledEndHours,
      disabledEndMinutes,
    });
  }
};
